module.exports = __webpack_public_path__ + "img/tab1.7d41e1ca.png";